import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const familyDirectory: RouteRecordRaw = {
  name: 'admin.familyDirectory',
  path: 'family-directory',
  component: () => import('pages/FamilyDirectory.vue'),
  meta: {
    roles: [Roles.RoomStaff],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
}
